import * as yup from 'yup';

export const corporateAddEmployeeValidationSchema = yup.object().shape({
    name: yup.string().required("Name is required"),
    phone_no: yup
        .string() // Use string for Yup validation
        .matches(/^\d+$/, "Phone number must be numeric")
        .min(6, "Phone number must be at least 6 characters")
        .required("Phone number is required"),
    ss_number: yup.string()
        .required("Social Security Number is required"),
    email: yup.string()
        .email("Invalid email address")
        .required("Email is required"),
    password: yup.string()
        .min(8, "Password must be at least 8 characters")
        .required("Password is required")
        .matches(/[A-Z]/, 'Password must contain at least one uppercase letter') // At least one uppercase
        .matches(/[0-9]/, 'Password must contain at least one number') // At least one number
        .matches(/[@$!%*?&]/, 'Password must contain at least one special character'), // At least one special character
    confirm_password: yup.string()
        .oneOf([yup.ref("password"), null], "Passwords must match")
        .required("Confirm password is required"),
    // address: yup.string()
    //     .required("Address is required"),
    about: yup.string()
        .max(500, "About section cannot exceed 500 characters")
        .required("About section is required"),
    profile: yup.mixed()
        .nullable()
        .required("Profile picture is required"),
    other: yup.mixed()
        .nullable()
        .required("document is required"),
});
